import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class VehicleOwnershipType extends AbstractModel {
  @autoserialize
  code: string;

  @autoserialize
  name: string;
}
